var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.uploading,
      expression: "uploading"
    }]
  }, [_c("div", {
    staticClass: "app-page-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("el-input", {
    staticClass: "app-search-input",
    attrs: {
      size: "mini",
      placeholder: "函证编码"
    },
    on: {
      change: _vm.codeChange
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.codeChange.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchKey,
      callback: function callback($$v) {
        _vm.searchKey = $$v;
      },
      expression: "searchKey"
    }
  }), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.searchList
    }
  }, [_vm._v("搜索")])], 1), _c("div", {
    staticClass: "right"
  }, [_vm.canBeCreate && !_vm.history ? _c("el-button", {
    staticClass: "app-inline-btn",
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: _vm.create
    }
  }, [_vm._v("新增函证")]) : _vm._e(), _vm.canBeCreate && !_vm.history ? _c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "",
      width: "340",
      trigger: "manual"
    },
    model: {
      value: _vm.downloadExcelModel.show,
      callback: function callback($$v) {
        _vm.$set(_vm.downloadExcelModel, "show", $$v);
      },
      expression: "downloadExcelModel.show"
    }
  }, [_c("div", {
    staticClass: "download-excel-form"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("el-select", {
    attrs: {
      size: "mini",
      clearable: "",
      placeholder: "请选择函证类型"
    },
    model: {
      value: _vm.downloadExcelModel.type,
      callback: function callback($$v) {
        _vm.$set(_vm.downloadExcelModel, "type", $$v);
      },
      expression: "downloadExcelModel.type"
    }
  }, _vm._l(_vm.correspondenceType, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1), _c("div", {
    staticClass: "item"
  }, [_c("el-date-picker", {
    attrs: {
      size: "mini",
      "value-format": "yyyy-MM-dd",
      clearable: "",
      type: "date",
      placeholder: "选择截止日期"
    },
    model: {
      value: _vm.downloadExcelModel.date,
      callback: function callback($$v) {
        _vm.$set(_vm.downloadExcelModel, "date", $$v);
      },
      expression: "downloadExcelModel.date"
    }
  })], 1), _c("div", {
    staticClass: "item"
  }, [_c("el-button", {
    attrs: {
      loading: _vm.loading,
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.downloadExcel
    }
  }, [_vm._v("导出")]), _c("el-button", {
    attrs: {
      loading: _vm.loading,
      type: "",
      size: "mini"
    },
    on: {
      click: function click($event) {
        _vm.downloadExcelModel.show = false;
      }
    }
  }, [_vm._v("关闭")])], 1)]), _c("el-button", {
    staticClass: "app-inline-btn",
    staticStyle: {
      "margin-left": "12px",
      "margin-right": "12px"
    },
    attrs: {
      slot: "reference",
      type: "text",
      size: "mini"
    },
    on: {
      click: function click($event) {
        _vm.downloadExcelModel.show = true;
      }
    },
    slot: "reference"
  }, [_vm._v("导出本作业函证数据")])], 1) : _vm._e(), _c("el-button", {
    key: "barcode",
    staticClass: "app-inline-btn",
    attrs: {
      type: "",
      disabled: _vm.selectedList.length === 0,
      size: "mini"
    },
    on: {
      click: _vm.toPrintBarcode
    }
  }, [_vm._v("批量打印函证编码(条形码)")]), _vm.isCpscAdmin ? _c("el-button", {
    key: "exportFile",
    staticClass: "app-inline-btn",
    attrs: {
      type: "primary",
      disabled: _vm.selectedList.length === 0,
      size: "mini"
    },
    on: {
      click: _vm.exportFile
    }
  }, [_vm._v("导出函证附件")]) : _vm._e(), _vm.isCpscAdmin ? _c("el-button", {
    key: "exportExcel",
    staticClass: "app-inline-btn",
    attrs: {
      type: "warning",
      size: "mini"
    },
    on: {
      click: _vm.exportExcel
    }
  }, [_vm._v("导出本页数据")]) : _vm._e(), _vm.importTemplate && !_vm.history ? _c("el-dropdown", {
    staticClass: "app-inline-btn",
    attrs: {
      size: "small"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    }
  }, [_vm._v(" 导入模板"), _c("i", {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-dropdown-item", [_vm._v("批量新增/覆写")]), _vm._v("a "), _c("el-dropdown-item", [_vm._v("批量维护发函快递数据")])], 1)], 1) : _vm._e(), !_vm.history ? _c("el-dropdown", {
    staticClass: "app-inline-btn",
    attrs: {
      size: "small"
    },
    on: {
      command: _vm.batchHandle
    }
  }, [_c("el-button", {
    attrs: {
      type: "success",
      size: "mini"
    }
  }, [_vm._v(" 批量操作"), _c("i", {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm._batchHandleList, function (item) {
    return _c("el-dropdown-item", {
      key: item.key,
      attrs: {
        disabled: _vm.selectedList.length === 0 || item.disabled,
        command: item.key
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1) : _vm._e(), _c("cpsc-sate-filter", {
    staticClass: "app-inline-btn",
    attrs: {
      "default-value": _vm.filterValue,
      data: _vm._filterData
    },
    on: {
      change: _vm.changeStatus
    }
  })], 1)]), _c("div", {
    staticClass: "content"
  }, [_c("custom-table", {
    ref: "table",
    attrs: {
      "filter-list-params": _vm.filterListParams,
      "filter-key": _vm.filterKey,
      "filter-value": _vm.filterValue,
      id: _vm.id,
      "task-detail": _vm.info,
      roles: _vm.roles,
      "is-manager": _vm.isManager,
      pageLoading: _vm.loading,
      "search-query": _vm.searchQuery,
      history: _vm.history,
      admin: _vm.admin
    },
    on: {
      change: _vm.getSelectedList
    }
  })], 1), _vm.template ? _c(_vm.template, {
    tag: "component"
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };